import { render } from "./AcumuladosReq.vue?vue&type=template&id=e3b8db6a&scoped=true"
import script from "./AcumuladosReq.vue?vue&type=script&lang=js"
export * from "./AcumuladosReq.vue?vue&type=script&lang=js"

import "./AcumuladosReq.vue?vue&type=style&index=0&id=e3b8db6a&scoped=true&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3b8db6a"]])

export default __exports__